// Note Almost an exact copy if this file is in @/features/project-survey/components/forms/ProjectSurveyRespondentsForm/utils/getFromRecipients.ts

import parsePhoneNumberFromString from 'libphonenumber-js/max';

type BaseRecipient = {
    type?: 'EMAIL' | 'SMS' | string;
    emailAddress?: string | null;
    phoneNumber?: string | null;
    respondentId: string;
    preRegisteredMetaQuestionResponses: ReadonlyArray<{
        questionId: string;
        selectedResponseOptions: ReadonlyArray<{
            value: number;
        }>;
    }>;
};

interface SimplifiedRecipient {
    type: 'EMAIL' | 'SMS';
    label: string;
    preRegisteredMetaQuestionResponses: ReadonlyArray<{
        readonly questionId: string;
        selectedResponseOptions: ReadonlyArray<{
            readonly value: number;
        }>;
    }>;
    respondentId: string;
}

export function emailAddressesFromRecipients<Recipient extends BaseRecipient>(
    recipients: ReadonlyArray<Recipient>,
): ReadonlyArray<SimplifiedRecipient> {
    const items: SimplifiedRecipient[] = [];
    recipients.forEach(
        ({
            type,
            emailAddress,
            preRegisteredMetaQuestionResponses,
            respondentId,
        }) => {
            if (type === 'EMAIL' && Boolean(emailAddress)) {
                items.push({
                    type,
                    label: emailAddress,
                    preRegisteredMetaQuestionResponses,
                    respondentId,
                });
            }
        },
    );
    return items;
}

export function phoneNumbersFromRecipients<Recipient extends BaseRecipient>(
    recipients: ReadonlyArray<Recipient>,
): SimplifiedRecipient[] {
    const items: SimplifiedRecipient[] = [];
    recipients.forEach(
        ({
            type,
            phoneNumber,
            preRegisteredMetaQuestionResponses,
            respondentId,
        }) => {
            if (type === 'SMS' && Boolean(phoneNumber)) {
                const parsedPhoneNumber =
                    parsePhoneNumberFromString(phoneNumber);
                items.push({
                    type,
                    label: parsedPhoneNumber?.isValid()
                        ? parsedPhoneNumber.formatInternational()
                        : phoneNumber,
                    preRegisteredMetaQuestionResponses,
                    respondentId,
                });
            }
        },
    );
    return items;
}
